export default "__VITE_ASSET__BjGRgUWt__"